<template>
  <div
    class="w-100 relative h-100"
    style="flex-grow: 1;"
  >
    <BgLeaves
      v-if="brand === 'lh'"
      :trigger="leaves"
      :position="[0, 1, 0, 1]"
      :inset="10"
    />
    <div
      class="flex flex-column items-start justify-center h-100 pr5 w-100 top-0"
      style="padding-left: 25vw;"
    >
      <div
        ref="title"
        class="f1 b mb4"
        :class="{
          'purple': brand === 'lh',
          'dark-gray': brand === 'lq'
        }"
      >
        Buying Process
      </div>
      <div
        ref="divider"
        class="bt bw1 w3"
        :class="{
          'b--purple': brand === 'lh',
          'b--dark-gray': brand === 'lq'
        }"
      />
      <div
        v-if="buyingProcess"
        class="flex w-100 items-stretch relative pr5"
        style="height: 16rem; margin: 9rem 6rem 9rem -5rem;"
      >
        <div class="w-10 self-center">
          <simple-svg
            class="dib w3"
            :class="{
              'purple': brand === 'lh',
              'dark-gray': brand === 'lq'
            }"
            :filepath="icon.search"
          />
        </div>
        <div class="flex relative w-100">
          <div
            ref="bar"
            class="absolute top-50 left-0 w-100 bb bw2"
            :class="{
              'b--purple': brand === 'lh',
              'b--dark-gray': brand === 'lq'
            }"
          />
          <div
            ref="timePoints"
            v-for="(step, index) in buyingProcess"
            :key="index"
            class="relative w-10 pt4 tc"
            style="height: 50%"
            :class="{
              'self-start' : index % 2 === 0,
              'self-end' : index % 2 !== 0
            }"
          >
            <simple-svg
              class="timeline-svg w3 dib"
              :class="{
                'purple': brand === 'lh',
                'silver': brand === 'lq'
              }"
              :filepath="step.icon"
            />

            <div
              class="timeline-dot dib w1 h1 absolute left-50 ba br-100 bw2 bg-white"
              :class="{
                'b--purple': brand === 'lh',
                'b--dark-gray': brand === 'lq',
                'bottom--1' : index % 2 === 0,
                'top--1' : index % 2 !== 0
              }"
              :style="getTransform(index)"
            />

            <div
              class="timeline-text dib absolute left--2 right--2"
              :style="getPosition(index)"
            >
              <div
                class="f5 fw6 lh-title pb2"
                :class="{
                  'purple': brand === 'lh',
                  'dark-gray': brand === 'lq'
                }"
                v-html="(index + 1) + '. ' + step.title"
              />
              <div
                class="lh-title f7 dark-gray"
                v-html="step.text"
              />
            </div>
          </div>
        </div>
        <div class="w-10 self-center tr">
          <simple-svg
            class="dib w3"
            :class="{
              'purple': brand === 'lh',
              'dark-gray': brand === 'lq'
            }"
            :filepath="icon.home"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gsap from 'gsap'
import transitions from '../../transitions.js'
import BgLeaves from '@/components/BgLeaves.vue'

export default {
  name: 'BuyingProcess',
  components: {
    BgLeaves
  },
  props: {
    brand: {
      type: String,
      default: 'lh'
    }
  },
  data () {
    return {
      // buyingProcess: [
      //   {
      //     title: '1. Find your new home',
      //     content: 'Browse our range of homes and find one that is perfect for you.',
      //     icon: require('@/assets/img/icon-landmark.svg')
      //   },
      //   {
      //     title: '2. Find your way to buy',
      //     content: 'At Laurus we offer a range of ways to buy your home, find the best one for you.',
      //     icon: require('@/assets/img/icon-papers.svg')
      //   },
      //   {
      //     title: '3. Make your reservation',
      //     content: 'Visit the Sales Centre to reserve your plot with our specialist Sales Advisors.',
      //     icon: require('@/assets/img/icon-pencil.svg')
      //   },
      //   {
      //     title: '4. Appoint a solicitor',
      //     content: 'You will need a solicitor to help with the legal process of buying your new home, and your IFA will help you find the right mortgage for you.',
      //     icon: require('@/assets/img/icon-pin.svg')
      //   },
      //   {
      //     title: '5. Exchange contacts',
      //     content: 'We will exchange contracts and your solicitor transfers your deposit.',
      //     icon: require('@/assets/img/icon-mail.svg')
      //   },
      //   {
      //     title: '6. Keeping you informed',
      //     content: 'Your dedicated Sales Advisor will keep you up to date on the progress of your new home.',
      //     icon: require('@/assets/img/icon-megaphone.svg')
      //   },
      //   {
      //     title: '7. Quality Assurance',
      //     content: 'We carry out regular checks to make sure all homes meet Laurus’ high standards.',
      //     icon: require('@/assets/img/icon-quality.svg')
      //   },
      //   {
      //     title: '8. Home demonstration',
      //     content: 'It’s now time for you to see your new home, your Sales Advisor will take you around your home and show you how everything works.',
      //     icon: require('@/assets/img/icon-ok.svg')
      //   },
      //   {
      //     title: '9. Time to move',
      //     content: 'Moving day is here! It’s time for us to hand over the keys to your new home and you can begin moving in.',
      //     icon: require('@/assets/img/icon-glass.svg')
      //   },
      //   {
      //     title: '10. Aftercare',
      //     content: 'Your Laurus journey doesn’t end here, our Aftercare team will be on hand to help you settle into your new home and assist with any minor issues.',
      //     icon: require('@/assets/img/icon-heart.svg')
      //   }
      // ],
      icon: {
        search: require('@/assets/img/icon-search.svg'),
        home: require('@/assets/img/icon-home.svg')
      },
      leaves: false
    }
  },
  computed: {
    buyingProcess () {
      if (this.$store.state.content && this.$store.state.content !== undefined) {
        return this.$store.state.content.about.buyingProcess
      } else {
        return null
      }
    },
    activeNav () {
      return this.$store.state.activeIndex
    }
  },
  methods: {
    getTransform (index) {
      if (index % 2 === 0) {
        return 'transform: translateX(-50%) translateY(-45%)'
      } else {
        return 'transform: translateX(-50%) translateY(55%)'
      }
    },
    getPosition (index) {
      if (index % 2 === 0) {
        return 'bottom: 100%'
      } else {
        return 'top: 100%'
      }
    },
    timelineAnim () {
      const bar = this.$refs.bar
      const timePoints = this.$refs.timePoints
      const dots = document.querySelectorAll('.timeline-dot')

      const tl = gsap.timeline({})
      tl.fromTo(bar,
        {
          width: 0 + '%'
        },
        {
          width: 100 + '%',
          delay: 1,
          duration: (dots.length) * 0.2,
          ease: 'none'
        }
      ).fromTo(dots,
        {
          scale: 0
        },
        {
          scale: 1,
          stagger: 0.2,
          duration: 0.2,
          delay: -(dots.length * 0.2) + 0.15,
          ease: 'back(1.4)'
        }
      ).fromTo(timePoints,
        {
          opacity: 0
        },
        {
          opacity: 1,
          delay: -(dots.length * 0.2) + 0.15,
          stagger: 0.2,
          duration: 0.4
        }
      )
    },
    titleAnim () {
      const divider = this.$refs.divider
      const title = this.$refs.title
      transitions.titleTransition(title, divider)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.leaves = true
      vm.timelineAnim()
      vm.titleAnim()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.leaves = false
    setTimeout(() => {
      next()
    }, 200)
  }
}
</script>
